export function getConfig(): any {
    return (<any>window)["_werkenbij_config"];
}

export function getSearchParams(): URLSearchParams {
    const searchParams = new URLSearchParams(window.location.search);
    return getCleanedSearchParams(searchParams);
}

export function getCleanedSearchParams(searchParams: URLSearchParams) {
    const cleanedSearchParams = new URLSearchParams(searchParams);
    const allowedParams = ["branch", "location", "organizationalUnit", "discipline"];

    searchParams.forEach((value, key) => {
        if (!allowedParams.includes(key)) {
            cleanedSearchParams.delete(key);
        }
    });
    return cleanedSearchParams;
}